import { xml2js } from 'xml-js'

export type ParsedActionStructure = {
  windowType?: string
  transferType?: string
  transfer?: string
  raw?: unknown
}

function readScalar(node: unknown): string | undefined {
  if (node == null) return undefined
  if (typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean') {
    const text = String(node).trim()
    return text || undefined
  }
  if (typeof node === 'object') {
    const record = node as Record<string, unknown>
    if (record._text != null) {
      const text = String(record._text).trim()
      return text || undefined
    }
    if (record._cdata != null) {
      const text = String(record._cdata).trim()
      return text || undefined
    }
  }
  return undefined
}

function readFromCompactRoot(root: Record<string, unknown>): ParsedActionStructure {
  const actionNode =
    (root.action as Record<string, unknown> | undefined) ??
    (root.Action as Record<string, unknown> | undefined) ??
    root

  const windowType = readScalar(actionNode.window__type)?.toUpperCase()
  const transferType = readScalar(actionNode.transferType)?.toLowerCase()
  const transfer = readScalar(actionNode.transfer)

  return {
    windowType,
    transferType,
    transfer,
    raw: actionNode,
  }
}

function parseStructureXml(xml: string): ParsedActionStructure {
  const trimmed = xml.trim()
  if (!trimmed) return {}
  try {
    const compact = xml2js(trimmed, { compact: true }) as Record<string, unknown>
    return readFromCompactRoot(compact)
  } catch {
    return {}
  }
}

export function parseActionStructure(structure: unknown): ParsedActionStructure {
  if (structure == null) return {}

  if (typeof structure === 'string') {
    return parseStructureXml(structure)
  }

  if (typeof structure === 'object') {
    const record = structure as Record<string, unknown>
    if (typeof record._text === 'string' && record._text.trim()) {
      return parseStructureXml(record._text)
    }
    if (typeof record._cdata === 'string' && record._cdata.trim()) {
      return parseStructureXml(record._cdata)
    }
    return readFromCompactRoot(record)
  }

  return {}
}
